enum Products {
  perks = "PERKS",
  recognition = "RECOGNITION",
  medical = "MEDICAL",
  onlineGP = "ONLINEGP",
  wellness = "WELLNESS",
  rewards = "FLEXIREWARDS",
  cultureHub = "CULTUREHUB",
  savings = "SAVINGS",
  cycleToWork = "CYCLETOWORK",
  homeAndElectronics = "HOMEANDELECTRONICS",
  annualLeavePurchase = "ANNUALLEAVEPURCHASE",
  carScheme = "CARSCHEME",
  payrollGiving = "PAYROLLGIVING",
  salaryFinance = "SALARYFINANCE",
  healthCashPlan = "HEALTHCASHPLAN",
  gymMembership = "GYMMEMBERSHIP",
  pensionAdvantage = "PENSIONADVANTAGE",
  travelAndLeisure = "TRAVELANDLEISURE",
  ctw = "CTW",
  he = "HE",
  alp = "ALP"
}

export default Products
